import React from 'react';

import {AttachmentMedia} from 'src/components/trigger-attachment/attachment-media';
import {fileAttachmentPreview} from 'src/components/trigger-attachment/trigger-attachment.module.styl';
import {
    isAttachmentUpdated,
} from 'src/modules/event-review/header-block/event-trigger-attachment/utils/isAttachmentUpdated';
import {EventDetailInfo} from 'src/openapi/models/EventDetailInfo';
import {TriggerAttachment} from 'src/openapi/models/TriggerAttachment';
import {getAttachmentCreationDate} from 'src/utils/getAttachmentCreationDate';

import {Group, Item} from '@pb/kit-component-group';
import {Icon, Icons, Sizes} from '@pb/kit-component-icon';

type Props = {
    attachment: TriggerAttachment,
    eventCodeInfo: EventDetailInfo | null,
    setFullscreen: (attachment: TriggerAttachment | null) => void,
};

export const AttachmentPreview = (props: Props) => {
    const {
        attachment,
        eventCodeInfo,
        setFullscreen,
    } = props;

    const isUpdated = isAttachmentUpdated(attachment, eventCodeInfo?.triggerAttachments);

    return (
        <Group direction="v" gap="xxs">
            <Group justify="center" alignItems="center" className={fileAttachmentPreview}>
                <AttachmentMedia
                    isPreview={true}
                    attachment={attachment}
                    setFullscreen={setFullscreen}
                />
            </Group>
            <Group justify="center" className={isUpdated ? 'highlighter-wrapper__highlight' : ''}>
                <Item>{getAttachmentCreationDate(attachment)}</Item>
                {!attachment.active ? <Icon type={Icons.EYE_SLASH} size={Sizes.Size_16}/> : null}
            </Group>
        </Group>
    );
};
